import { Link } from "react-router-dom";
import { ArrowRight, Package } from "lucide-react";

export const EmptyOrders = () => (
  <div
    className="rounded-2xl border border-dashed border-neutral-300 bg-white p-10 text-center"
    data-testid="account-no-orders"
  >
    <div className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-neutral-100">
      <Package size={22} className="text-neutral-400" />
    </div>
    <p className="mt-4 font-heading text-base font-semibold">No orders yet</p>
    <p className="mx-auto mt-1 max-w-sm text-sm leading-relaxed text-neutral-500">
      Your orders will appear here once you place your first order. Anything you buy with this email at our
      checkout shows up automatically.
    </p>
    <Link
      to="/shop"
      data-testid="account-shop-cta"
      className="group mt-6 inline-flex items-center gap-2 rounded-full bg-neutral-900 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-neutral-700"
    >
      Start Shopping
      <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
    </Link>
  </div>
);
